var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4409_133)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 55,
    height: 55,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3 39.9195V45.0695C55.3 48.1495 53.54 49.4695 50.9 49.4695H42.11C41.66 49.4695 41.23 49.4295 40.83 49.3395C40.58 49.2995 40.34 49.2295 40.12 49.1495C38.62 48.5895 37.71 47.2895 37.71 45.0695V39.9195C37.71 36.8395 39.47 35.5195 42.11 35.5195H50.9C53.14 35.5195 54.75 36.4695 55.18 38.6395C55.25 39.0395 55.3 39.4495 55.3 39.9195Z",
    stroke: "#2D995F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3011 42.9196V48.0696C58.3011 51.1496 56.5411 52.4696 53.9011 52.4696H45.1111C44.3711 52.4696 43.7011 52.3697 43.1211 52.1497C41.9311 51.7097 41.1211 50.7997 40.8311 49.3397C41.2311 49.4297 41.6611 49.4696 42.1111 49.4696H50.9011C53.5411 49.4696 55.3011 48.1496 55.3011 45.0696V39.9196C55.3011 39.4496 55.2611 39.0296 55.1811 38.6396C57.0811 39.0396 58.3011 40.3796 58.3011 42.9196Z",
    stroke: "#2D995F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4984 45.1394C47.9564 45.1394 49.1384 43.9574 49.1384 42.4994C49.1384 41.0414 47.9564 39.8594 46.4984 39.8594C45.0404 39.8594 43.8584 41.0414 43.8584 42.4994C43.8584 43.9574 45.0404 45.1394 46.4984 45.1394Z",
    stroke: "#2D995F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7798 40.2998V44.6998",
    stroke: "#2D995F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2217 40.2998V44.6998",
    stroke: "#2D995F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4409_133",
    x: 0,
    y: 0,
    width: 95,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.490278 0 0 0 0 0.22698 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4409_133"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4409_133",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestIcon);
export default __webpack_public_path__ + "static/media/Invest-icon.953a1ba38ab44787d924ce4155c8677a.svg";
export { ForwardRef as ReactComponent };